import React, { FC, memo } from 'react';

import usePrefix from 'utils/usePrefix';

import { SubmissionFormDescriptionStyled } from './styles';

const SubmissionFormDescription: FC = () => {
  const t = usePrefix('ResqlExpert');
  
  return (
    <SubmissionFormDescriptionStyled>
      <h2>{t('new_submission')}</h2>
      <h3>{t('form_title')}</h3>
      <p>{t('form_description')}</p>
    </SubmissionFormDescriptionStyled>
  );
};

export default memo(SubmissionFormDescription);
